import axios from 'axios';
import { consoleErrorMessage } from 'utils/commonFunctions/CommonFunctions';
import { UNEXPECTED_ERROR_MESSAGE } from '../common-constants';

export const handleThunkError = (
  error: any,
  rejectWithValue: (value: unknown) => any
) => {
  if (axios.isAxiosError(error)) {
    const errorMessage = consoleErrorMessage(error);
    return rejectWithValue(errorMessage ?? error);
  }
  consoleErrorMessage(UNEXPECTED_ERROR_MESSAGE);
  return rejectWithValue(UNEXPECTED_ERROR_MESSAGE);
};

export const handleThunkErrorWithStatus = (
  error: any,
  rejectWithValue: (value: unknown) => any
) => {
  if (axios.isAxiosError(error)) {
    const errorMessage = consoleErrorMessage(error);
    const statusCode = error.response?.status;
    return rejectWithValue({
      message: errorMessage ?? error.message,
      status: statusCode,
    });
  }
  consoleErrorMessage(UNEXPECTED_ERROR_MESSAGE);
  return rejectWithValue({ message: UNEXPECTED_ERROR_MESSAGE });
};
